export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Object, checked, products, useProductId) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (! products) {
pug_html = pug_html + "\u003Cdiv\u003ELoading products, please wait...\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"controls\"\u003E\u003Cselect name=\"useproduct\"\u003E";
// iterate products
;(function(){
  var $$obj = products;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var product = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", product.id, true, true)+pug_attr("selected", product.id==useProductId, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var product = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", product.id, true, true)+pug_attr("selected", product.id==useProductId, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E\u003Cbutton class=\"use-product\"\u003EUse product's options\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (checked) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cul class=\"products\"\u003E";
// iterate checked
;(function(){
  var $$obj = checked;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var product = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"status\"\u003E";
if (! product.variantsComparison || product.variantsComparison.same) {
pug_html = pug_html + "\u003Cdiv class=\"good\"\u003EOK\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"bad\"\u003ENOT OK\u003C\u002Fdiv\u003E\u003Cdiv class=\"oldVariants variants\"\u003EOld variants : " + (pug_escape(null == (pug_interp = product.variantsComparison.oldVariants.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.oldVariants
;(function(){
  var $$obj = product.variantsComparison.oldVariants;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var variant = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var choice = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var choice = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newVariants variants\"\u003ENew variants : " + (pug_escape(null == (pug_interp = product.variantsComparison.newVariants.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.newVariants
;(function(){
  var $$obj = product.variantsComparison.newVariants;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var variant = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var choice = $$obj[pug_index6];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index6];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var choice = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

// iterate product.variantsComparison.newOptions
;(function(){
  var $$obj = product.variantsComparison.newOptions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var option = $$obj[pug_index8];
pug_html = pug_html + "\u003Cli\u003E(Option) " + (pug_escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\n";
// iterate option.choices
;(function(){
  var $$obj = option.choices;
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var choice = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var option = $$obj[pug_index8];
pug_html = pug_html + "\u003Cli\u003E(Option) " + (pug_escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\n";
// iterate option.choices
;(function(){
  var $$obj = option.choices;
  if ('number' == typeof $$obj.length) {
      for (var pug_index10 = 0, $$l = $$obj.length; pug_index10 < $$l; pug_index10++) {
        var choice = $$obj[pug_index10];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index10 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index10];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addVariants variants\"\u003EVariants to add : " + (pug_escape(null == (pug_interp = product.variantsComparison.toAdd.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.toAdd
;(function(){
  var $$obj = product.variantsComparison.toAdd;
  if ('number' == typeof $$obj.length) {
      for (var pug_index11 = 0, $$l = $$obj.length; pug_index11 < $$l; pug_index11++) {
        var variant = $$obj[pug_index11];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index12 = 0, $$l = $$obj.length; pug_index12 < $$l; pug_index12++) {
        var choice = $$obj[pug_index12];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index12 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index12];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index11 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index11];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index13 = 0, $$l = $$obj.length; pug_index13 < $$l; pug_index13++) {
        var choice = $$obj[pug_index13];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index13 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index13];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addVariants variants\"\u003EVariants to delete : " + (pug_escape(null == (pug_interp = product.variantsComparison.toDelete.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.toDelete
;(function(){
  var $$obj = product.variantsComparison.toDelete;
  if ('number' == typeof $$obj.length) {
      for (var pug_index14 = 0, $$l = $$obj.length; pug_index14 < $$l; pug_index14++) {
        var variant = $$obj[pug_index14];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index15 = 0, $$l = $$obj.length; pug_index15 < $$l; pug_index15++) {
        var choice = $$obj[pug_index15];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index15 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index15];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index14 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index14];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index16 = 0, $$l = $$obj.length; pug_index16 < $$l; pug_index16++) {
        var choice = $$obj[pug_index16];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index16 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index16];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cbutton" + (" class=\"update-product\""+pug_attr("data-id", product.id, true, true)) + "\u003EUpdate Variants\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var product = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"status\"\u003E";
if (! product.variantsComparison || product.variantsComparison.same) {
pug_html = pug_html + "\u003Cdiv class=\"good\"\u003EOK\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"bad\"\u003ENOT OK\u003C\u002Fdiv\u003E\u003Cdiv class=\"oldVariants variants\"\u003EOld variants : " + (pug_escape(null == (pug_interp = product.variantsComparison.oldVariants.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.oldVariants
;(function(){
  var $$obj = product.variantsComparison.oldVariants;
  if ('number' == typeof $$obj.length) {
      for (var pug_index17 = 0, $$l = $$obj.length; pug_index17 < $$l; pug_index17++) {
        var variant = $$obj[pug_index17];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index18 = 0, $$l = $$obj.length; pug_index18 < $$l; pug_index18++) {
        var choice = $$obj[pug_index18];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index18 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index18];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index17 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index17];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index19 = 0, $$l = $$obj.length; pug_index19 < $$l; pug_index19++) {
        var choice = $$obj[pug_index19];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index19 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index19];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"newVariants variants\"\u003ENew variants : " + (pug_escape(null == (pug_interp = product.variantsComparison.newVariants.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.newVariants
;(function(){
  var $$obj = product.variantsComparison.newVariants;
  if ('number' == typeof $$obj.length) {
      for (var pug_index20 = 0, $$l = $$obj.length; pug_index20 < $$l; pug_index20++) {
        var variant = $$obj[pug_index20];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index21 = 0, $$l = $$obj.length; pug_index21 < $$l; pug_index21++) {
        var choice = $$obj[pug_index21];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index21 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index21];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index20 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index20];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index22 = 0, $$l = $$obj.length; pug_index22 < $$l; pug_index22++) {
        var choice = $$obj[pug_index22];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index22 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index22];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

// iterate product.variantsComparison.newOptions
;(function(){
  var $$obj = product.variantsComparison.newOptions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index23 = 0, $$l = $$obj.length; pug_index23 < $$l; pug_index23++) {
        var option = $$obj[pug_index23];
pug_html = pug_html + "\u003Cli\u003E(Option) " + (pug_escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\n";
// iterate option.choices
;(function(){
  var $$obj = option.choices;
  if ('number' == typeof $$obj.length) {
      for (var pug_index24 = 0, $$l = $$obj.length; pug_index24 < $$l; pug_index24++) {
        var choice = $$obj[pug_index24];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index24 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index24];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index23 in $$obj) {
      $$l++;
      var option = $$obj[pug_index23];
pug_html = pug_html + "\u003Cli\u003E(Option) " + (pug_escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\n";
// iterate option.choices
;(function(){
  var $$obj = option.choices;
  if ('number' == typeof $$obj.length) {
      for (var pug_index25 = 0, $$l = $$obj.length; pug_index25 < $$l; pug_index25++) {
        var choice = $$obj[pug_index25];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index25 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index25];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addVariants variants\"\u003EVariants to add : " + (pug_escape(null == (pug_interp = product.variantsComparison.toAdd.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.toAdd
;(function(){
  var $$obj = product.variantsComparison.toAdd;
  if ('number' == typeof $$obj.length) {
      for (var pug_index26 = 0, $$l = $$obj.length; pug_index26 < $$l; pug_index26++) {
        var variant = $$obj[pug_index26];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index27 = 0, $$l = $$obj.length; pug_index27 < $$l; pug_index27++) {
        var choice = $$obj[pug_index27];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index27 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index27];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index26 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index26];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index28 = 0, $$l = $$obj.length; pug_index28 < $$l; pug_index28++) {
        var choice = $$obj[pug_index28];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index28 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index28];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addVariants variants\"\u003EVariants to delete : " + (pug_escape(null == (pug_interp = product.variantsComparison.toDelete.length) ? "" : pug_interp)) + "\n\n\u003Ca class=\"show-variants clickable\"\u003E(show\u002Fhide)\u003C\u002Fa\u003E\u003Col class=\"variants-hidden\"\u003E";
// iterate product.variantsComparison.toDelete
;(function(){
  var $$obj = product.variantsComparison.toDelete;
  if ('number' == typeof $$obj.length) {
      for (var pug_index29 = 0, $$l = $$obj.length; pug_index29 < $$l; pug_index29++) {
        var variant = $$obj[pug_index29];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index30 = 0, $$l = $$obj.length; pug_index30 < $$l; pug_index30++) {
        var choice = $$obj[pug_index30];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index30 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index30];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index29 in $$obj) {
      $$l++;
      var variant = $$obj[pug_index29];
pug_html = pug_html + "\u003Cli\u003E\u003Cdiv class=\"price\"\u003E$" + (pug_escape(null == (pug_interp = variant.price || variant.variant.priceData.price) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate Object.keys(variant.choices)
;(function(){
  var $$obj = Object.keys(variant.choices);
  if ('number' == typeof $$obj.length) {
      for (var pug_index31 = 0, $$l = $$obj.length; pug_index31 < $$l; pug_index31++) {
        var choice = $$obj[pug_index31];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index31 in $$obj) {
      $$l++;
      var choice = $$obj[pug_index31];
pug_html = pug_html + "\u003Cdiv class=\"choice\"\u003E" + (pug_escape(null == (pug_interp = choice) ? "" : pug_interp)) + ": " + (pug_escape(null == (pug_interp = variant.choices[choice]) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cbutton" + (" class=\"update-product\""+pug_attr("data-id", product.id, true, true)) + "\u003EUpdate Variants\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "Object" in locals_for_with ?
        locals_for_with.Object :
        typeof Object !== 'undefined' ? Object : undefined, "checked" in locals_for_with ?
        locals_for_with.checked :
        typeof checked !== 'undefined' ? checked : undefined, "products" in locals_for_with ?
        locals_for_with.products :
        typeof products !== 'undefined' ? products : undefined, "useProductId" in locals_for_with ?
        locals_for_with.useProductId :
        typeof useProductId !== 'undefined' ? useProductId : undefined));
    ;;return pug_html;}